import { PlayerEnvironment } from "../player_environment";
import CookieUtils from '../utils/cookie_utils';
import UserSession from '../utils/user_session'

export default class Adult {
  static runPlugin(options) {
    if (options.enable) {
      const adult = new Adult(options);
      adult.checkUserSession();
    }
  }

  constructor(options = {}) {
    this._player = options.player;
    this._testMode = options.testMode;
    this._userId = undefined;
  }

  player() {
    return this._player;
  }

  testMode() {
    return this._testMode;
  }

  userId() {
    return this._userId;
  }

  checkUserSession() {
    if (UserSession.isLoggedIn()) {
      this._userId = UserSession.userId();
    }
    this.init(this.userId());
  }

  init(userId) {
    if (Adult.shouldSkipAdultBlocker()) {
      Adult.setAdultConfirmId(userId);
      return;
    }

    const adultConfirmId = CookieUtils.getCookie('adult_confirm_id');
    const userIsLogin = userId !== undefined;
    const userHasConfirm = Adult.userHasConfirm(this.userId(), adultConfirmId);

    if (!userIsLogin) {
      Adult.displayAdultBlocker(this.player(), userId);
    } else if (userIsLogin && !userHasConfirm) {
      Adult.displayAdultBlocker(this.player(), userId);
    }
  }

  static shouldSkipAdultBlocker() {
    return PlayerEnvironment.locationSearch().includes('pb_sac');
  }

  static displayAdultBlocker(player, userId) {
    const notice = Adult.createAdultNotice();
    const adultContainer = Adult.createAdultContainer();
    const descriptionContainer = Adult.createDescriptionContainer();
    const descriptionTop = Adult.createDescriptionTop('Konten untuk umur 18+');
    const descriptionBottom = Adult.createDescriptionBottom('Konfirmasi untuk menonton video ini');
    const actionsContainer = Adult.createActionsContainer();
    const action = userId !== undefined ?
      Adult.createActionConfirm('Konfirmasi', notice, player, userId) :
      Adult.createActionSignIn();

    descriptionContainer.appendChild(descriptionTop);
    descriptionContainer.appendChild(descriptionBottom);
    actionsContainer.appendChild(action);
    adultContainer.appendChild(descriptionContainer);
    adultContainer.appendChild(actionsContainer);
    notice.appendChild(adultContainer);
    player.el().appendChild(notice);
  }

  static unfreeze(player) {
    player.tech().play();
  }

  static destroy(notice) {
    notice.parentNode.removeChild(notice);
  }

  static createAdultNotice() {
    const notice = document.createElement("div");
    const preventClickPassThroughPlayer = (e) => {
      e.stopPropagation();
    };
    notice.className = "vjs-adult";
    notice.onclick = preventClickPassThroughPlayer;
    notice.ontouchend = preventClickPassThroughPlayer;

    return notice;
  }

  static createDescriptionContainer() {
    const container = document.createElement('div');
    container.className = "vjs-adult__description";

    return container;
  }

  static createAdultContainer() {
    const container = document.createElement("div");
    container.className = "vjs-adult-container";

    return container;
  }

  static createDescriptionTop(content) {
    const descriptionTop = document.createElement('p');
    descriptionTop.className = "vjs-adult__description-text-top";
    descriptionTop.innerText = content;
    descriptionTop.textContent = content;
    return descriptionTop;
  }

  static createDescriptionBottom(content) {
    const descriptionBottom = document.createElement('p');
    descriptionBottom.className = 'vjs-adult__description-text-bottom';
    descriptionBottom.innerText = content;
    descriptionBottom.textContent = content;

    return descriptionBottom;
  }

  static createActionsContainer() {
    const actionsContainer = document.createElement('div');
    actionsContainer.className = "vjs-adult__actions";

    return actionsContainer;
  }

  static createActionConfirm(content, notice, player, userId) {
    const actionConfirm = document.createElement('a');
    actionConfirm.className = "vjs-adult__actions-button";
    actionConfirm.innerText = content;
    actionConfirm.textContent = content;
    actionConfirm.onclick = actionConfirm.ontouchend = () => {
      Adult.unfreeze(player);
      Adult.destroy(notice);
      Adult.setAdultConfirmId(userId);
    };

    return actionConfirm;
  }

  static setAdultConfirmId(userId) {
    const adultConfirmId = CookieUtils.getCookie('adult_confirm_id');

    if (adultConfirmId !== userId) {
      CookieUtils.setCookie('adult_confirm_id', userId, Adult.getAdultConfirmExpiry());
    }
  }

  static createActionSignIn() {
    const actionConfirm = document.createElement('a');
    actionConfirm.className = 'vjs-adult__actions-button';
    actionConfirm.innerText = 'Sign In';
    actionConfirm.textContent = 'Sign In';
    actionConfirm.href = Adult.getSignInUrl();

    return actionConfirm;
  }

  static getSignInUrl() {
    const path = PlayerEnvironment.pathname();
    const search = PlayerEnvironment.locationSearch();

    return `/users/login?user_return_to=${path}${search}`;
  }

  static userHasConfirm(userId, adultConfirmId) {
    return userId == adultConfirmId;
  }

  static getAdultConfirmExpiry() {
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);

    return expiryDate.toUTCString();
  }
}
